// One device at a time. Signing in elsewhere ends this device's session on
// the server (see migration 20261017000100_single_device.sql); this notices
// and signs the device out with an explanation.
import { supabase } from '@/lib/supabase/client';

export const OTHER_DEVICE_REASON = 'other_device';

/** True for errors meaning this device's session was ended by a sign-in elsewhere. */
export function isSessionReplaced(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const e = error as { hint?: string | null; code?: string };
  return e.hint === 'session_replaced' || e.code === 'session_not_found' || e.code === 'refresh_token_not_found';
}

let ending = false;

/** Clears this device's session and goes to the sign-in page with a note. */
export async function endReplacedSession(): Promise<void> {
  if (ending) return;
  ending = true;
  try {
    // Local only: the server session is already gone, and a global sign-out
    // would end the new device's session too.
    await supabase.auth.signOut({ scope: 'local' });
  } finally {
    window.location.replace(`/login?reason=${OTHER_DEVICE_REASON}`);
  }
}

/** Checks with the server that this device's session is still the active one. */
export async function checkSessionStillActive(): Promise<void> {
  const { error } = await supabase.auth.getUser();
  if (isSessionReplaced(error)) await endReplacedSession();
}
